import React from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
interface BioProps {
  onOpenPopup: () => void;
}
export function Bio({
  onOpenPopup
}: BioProps) {
  return <section className="py-20 bg-black border-t border-gray-900" data-id="element-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto" data-id="element-10">
          {/* Left Column - Image */}
          <div className="w-full lg:w-5/12 flex justify-center" data-id="element-11">
            <div className="w-full max-w-md aspect-[3/4] relative" data-id="element-12">
              <MediaPlaceholder type="image" text="[Foto de Autor (Ej: Santiago Bilbao)]" className="w-full h-full bg-black border-gray-800" data-id="element-13" />
            </div>
          </div>

          {/* Right Column - Text */}
          <div className="w-full lg:w-7/12 text-left space-y-6" data-id="element-14">
            <h2 className="text-3xl md:text-4xl font-bold leading-tight" data-id="element-15">
              Así fue como construí un negocio de{' '}
              <span className="text-brand-orange" data-id="element-16">+6 cifras en 1 año</span>{' '}
              <span className="text-brand-orange underline decoration-2 underline-offset-4" data-id="element-17">
                vendiendo mis propios
              </span>{' '}
              infoproductos en internet
            </h2>

            <div className="space-y-4 text-gray-300 text-lg leading-relaxed" data-id="element-18">
              <p data-id="element-19">
                Hola, soy Santiago Bilbao y no soy ningún genio, ni un
                superdotado, realmente soy como vos. Empecé a vender al público
                y en Productos Digitales antes de mis 20 años hasta construir un
                negocio con el que facturo Múltiples 6 Cifras.
              </p>
              <p data-id="element-20">
                Hoy cuento con una Academia en la que más de 500 alumnos me
                toman como su mentor. ¿Y cómo lo he logrado? Tengo un método, un
                paso a paso que hoy me gusta decir, un sistema para hacerlo. Y
                por primera vez quiero enseñarlo a otras personas para que
                también lo puedan lograr.
              </p>
              <p data-id="element-21">
                Si estás leyendo esto es por que tal vez sientas que tu vida se
                trata de algo más que correr en la "carrera de la rata"{' '}
                <em className="text-gray-400" data-id="element-22">
                  (trabajar por dinero para pagar deudas y quedarse sin dinero
                  entonces repetir)
                </em>{' '}
                y querés hacer algo que te permita convertir tu computadora en
                tu oficina y mejorar tu calidad de vida.
              </p>
              <p data-id="element-23">
                Y yo te prometo que en estas 2 clases te voy a enseñar
                exactamente cómo yo lo hice.
              </p>
              <p className="font-bold text-white" data-id="element-24">
                Regístrate a la{' '}
                <span className="text-brand-orange" data-id="element-25">Masterclass</span>, y crea
                tu primer producto digital.
              </p>
            </div>

            <div className="pt-6" data-id="element-26">
              <button onClick={onOpenPopup} className="w-full sm:w-auto px-8 py-4 bg-brand-orange hover:bg-red-600 text-white text-lg font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 box-glow" data-id="element-27">
                ACCEDER AL CURSO GRATIS
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}